import { render } from "./IconFacebook.vue?vue&type=template&id=a8801ccc&scoped=true&ts=true"
import script from "./IconFacebook.vue?vue&type=script&lang=ts"
export * from "./IconFacebook.vue?vue&type=script&lang=ts"

import "./IconFacebook.vue?vue&type=style&index=0&id=a8801ccc&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src866133389/src/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a8801ccc"]])

export default __exports__